import { UserDetailedInfo } from "@/types";

export const getUserActivityText = ({
  occupation,
  locationWorkplace,
}: Pick<UserDetailedInfo, "occupation" | "locationWorkplace">) => {
  if (locationWorkplace && !occupation) {
    return `Works at ${locationWorkplace}`;
  } else if (occupation && !locationWorkplace) {
    return `${occupation}`;
  } else if (occupation && locationWorkplace) {
    return `${occupation} at ${locationWorkplace}`;
  } else if (!occupation && !locationWorkplace) {
    return "";
  }
};
